import React from 'react';
import { Select } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import FormErrorMessage from '@/shared/components/FormErrorMessage';

const TYPE = {
  ADULT: 'ADULT',
  CHILD: 'CHILD',
};

const TitleSelect = ({ error, type = TYPE.ADULT, ...props }) => (
  <>
    <Select
      error={!!error}
      mb="0"
      {...props} // eslint-disable-line react/jsx-props-no-spreading
    >
      <option value="">Please select</option>
      {
        {
          [TYPE.ADULT]: (
            <>
              <option value="Mr">Mr</option>
              <option value="Mrs">Mrs</option>
              <option value="Miss">Miss</option>
              <option value="Ms">Ms</option>
              <option value="Dr">Dr</option>
              <option value="Professor">Professor</option>
              <option value="Captain">Captain</option>
              <option value="Reverend">Reverend</option>
              <option value="Honourable">Honourable</option>
              <option value="Sir">Sir</option>
              <option value="Lady">Lady</option>
              <option value="Ambassador">Ambassador</option>
              <option value="Lord">Lord</option>
              <option value="Brigadier">Brigadier</option>
              <option value="Senator">Senator</option>
              <option value="Dame">Dame</option>
              <option value="Justice">Justice</option>
            </>
          ),
          [TYPE.CHILD]: (
            <>
              <option value="Master">Master</option>
              <option value="Miss">Miss</option>
            </>
          ),
        }[type]
      }
    </Select>
    {error && <FormErrorMessage text={error} />}
  </>
);

TitleSelect.propTypes = {
  error: PropTypes.string,
  type: PropTypes.oneOf(Object.values(TYPE)),
  ...Select.propTypes,
};

TitleSelect.TYPE = TYPE;

export default TitleSelect;
